import { render, staticRenderFns } from "./PeriodicalProximity.vue?vue&type=template&id=47a93b42&scoped=true"
import script from "./PeriodicalProximity.vue?vue&type=script&lang=js"
export * from "./PeriodicalProximity.vue?vue&type=script&lang=js"
import style0 from "./PeriodicalProximity.vue?vue&type=style&index=0&id=47a93b42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a93b42",
  null
  
)

export default component.exports